@if (data()) {
<section class="question-card" [id]="'block-' + data().id">
  @if (data()?.header?.length > 0) {
    <h2 class="question-card__header">
      {{ data()?.header }}
    </h2>
  }
  <div class="question-card__body">
    @if (inputFormControl()) {
      <form>
        <div class="options-list">
          @for (radioButton of data().options; track radioButton; let i = $index) {
            <div class="option-item">
              <label
                class="option-label"
                [class.disabled]="isInputDisabled()"
                [attr.for]="data().id + data().position.toString() + i"
                >
                @if (!isInputDisabled()) {
                  <input
                    [id]="data().id + data().position.toString() + i"
                    type="radio"
                    [value]="radioButton.position"
                    [attr.name]="data().id"
                    />
                }
                @if (isInputDisabled()) {
                  <input
                    [id]="data().id + data().position.toString() + i"
                    [checked]="data().value === radioButton.position"
                    type="radio"
                    disabled
                    [value]="radioButton.position"
                    [attr.name]="data().id"
                    />
                }
                <span>{{ radioButton.label }}</span>
              </label>
              @if (
                isInputDisabled() ||
                (inputFormControl().get(data().id).dirty &&
                data().options[inputFormControl().get(data().id).value]
                ?.correct_selection !== true)
                ) {
                @if (radioButton?.correct_selection === true) {
                  <p class="smart-answer smart-answer--correct">
                    <i class="ft-check" aria-hidden="true"></i>
                    <b>{{ correctAnswerLabel() }}</b>
                  </p>
                }
                @if (radioButton?.correct_selection === false) {
                  <p class="smart-answer smart-answer--incorrect">
                    <i class="ft-x" aria-hidden="true"></i>
                    {{ incorrectAnswerLabel() }}
                  </p>
                }
              }
            </div>
          }
          @if (
            data().options[inputFormControl().get(data().id).value]?.correct_selection
            ) {
            <p class="smart-feedback">
              {{ data().options[inputFormControl().get(data().id).value]?.feedback_text }}
            </p>
          }
        </div>
      </form>
    }
  </div>
</section>
}
